/* eslint-disable */

import React from "react";
import Loader from "react-spinner-loader";

const AppLoader = ({ minHeight = "60vh" }) => {
  return (
    <div
      style={{
        minHeight,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader show={true} spinnerSize="60px" radius="10" />
    </div>
  );
};

export default AppLoader;
